import MDButton from "components/MDButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useEffect, useState } from "react";
import MDModal from "components/MDModal";
import MDInput from "components/MDInput";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
const PlansModal = ({ data, onLoad }) => {
  const Service = useAppServices();
  const { id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false);
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false);
    const [selectedValue, setSelectedValue] = useState('onetime');
    const [selectedtype, setSelectedtype] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setProcessing(true);
      let plans = []
      plans = data.plans
      const plan = {
        name: e.target.name.value,
        plan_id: e.target.plan_id.value,
        price: e.target.price.value,
        pricing: selectedValue,
        selectedtype: selectedtype,
        location_price: selectedtype ? e.target.location_price.value : null
      }
      plans.push(plan)
      const payload = {
        plans: plans,
        _id: id,
      };
      const { response } = await Service.snapshot_onboarding.update({ payload });
      if (response) {
        setOpenAddProduct(false);
        setProcessing(false);
        onLoad();
      } else {
        setProcessing(false);
      }
    };
    const handleChange = (event) => {
      setSelectedValue(event.target.value);
    };
    const handletype = (event) => {
      setSelectedtype(event.target.checked);
    };
    return (
      <MDModal open={open} onClose={onClose} width={600} >
        <MDBox>
          <MDTypography component="h1" mb={3} variant="h5">
            Plan
          </MDTypography>

          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={{ width: 550 }}
          >
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Plan Name
                </MDTypography>
                <MDInput
                  defaultValue=""
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Plan Name"
                  name="name"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Plan ID
                </MDTypography>
                <MDInput
                  defaultValue=""
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Plan ID"
                  name="plan_id"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Pricing
                </MDTypography>
                <Switch defaultChecked={selectedtype} onChange={handletype} />
                <MDTypography variant="button" gutterBottom>
                  Set up different pricing for agency and sub-account
                </MDTypography>
                <RadioGroup
                  aria-label="options"
                  name="options"
                  sx={{ display: "-webkit-box" }}
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <FormControlLabel value="free" control={<Radio />} label="free" />
                  <FormControlLabel value="onetime" control={<Radio />} label="onetime" />
                  <FormControlLabel value="monthly" control={<Radio />} label="monthly" />
                  <FormControlLabel value="yearly" control={<Radio />} label="yearly" />
                </RadioGroup>
                {/* <MDInput
                  defaultValue=""
                  id="bootstrap-input"
                  fullWidth
                  placeholder="Plan Price"
                  name="price"
                /> */}
              </MDBox>
            </Grid>
            {
                      selectedValue != "free"  &&     <Grid item md={12}>
                      
                      <MDBox mb={1}>
                        <MDTypography variant="button" display="block" gutterBottom>
                          {selectedtype ? "Agency Amount" : "Amount"}
                        </MDTypography>
                        <MDInput
                          defaultValue=""
                          id="bootstrap-input"
                          fullWidth
                          placeholder="Plan Price"
                          name="price"
                        />
                      </MDBox>
                      {selectedtype && <MDBox mb={1}>
                        <MDTypography variant="button" display="block" gutterBottom>
                          Location Amount
                        </MDTypography>
                        <MDInput
                          defaultValue=""
                          id="bootstrap-input"
                          fullWidth
                          placeholder="Plan Price"
                          name="price"
                        />
                      </MDBox>}
        
                    </Grid>
                    }

            <MDBox>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                disabled={processing}
                loading={processing}
                sx={{ mt: 4, mb: 1 }}
                fullWidth
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal >
    );
  }
  const closeAddProduct = (subscription) => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      <MDButton
        sx={{ marginLeft: 3 }}
        variant="outlined"
        color="info"
        startIcon={<AddBoxIcon />}
        onClick={() => setOpenAddProduct(true)}
      >
        Plan
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  );
};

export default PlansModal;
